exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container.summary-questions {\n  flex: 1 0 auto;\n  padding-bottom: 20px;\n}\n.container.summary-questions th.yes-no,\n.container.summary-questions td.yes-no {\n  width: 50px;\n}\n.container.summary-questions th.behavior,\n.container.summary-questions td.behavior {\n  width: 200px;\n}\n.container.summary-questions th.characteristic,\n.container.summary-questions td.characteristic {\n  width: 200px;\n}\n.container.summary-questions table.checklist td.notes textarea {\n  width: 100%;\n}\n.container.summary-questions table.structural input.notes {\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/olos/styles/SummaryQuestions.styl
// module id = 1916
// module chunks = 1